import { firestore, auth } from "firebase";
import router from "../../router";
//import tree from "../../plugins/tree";
import getNestedChildren from "../../plugins/getNestedChildren";
export default {
  namespaced: true,
  state: {
    commentary: [],
    comment: {},
    child: []
  },
  actions: {
    // eslint-disable-next-line no-unused-vars
    listCommentary({ commit }) {
      const topicID = router.currentRoute.params.topic_id;
      const projectID = router.currentRoute.params.project_id;
      const refComentary = firestore()
        .collection("Project")
        .doc(projectID)
        .collection("Topic")
        .doc(topicID)
        .collection(`Comment`)
        .where("parent_id", "==", "");
      refComentary
        .get()
        .then(querySnapshot => {
          let information = [];
          let arr = [];
          querySnapshot.forEach(document => {
            information = document.doc.data();
            information.comment_id = document.id;
            information.topic_id = topicID;
            arr.push(information);
          });
          //const result = tree(arr);
          // eslint-disable-next-line no-console
          //commit("INSERT_LIST_COMMENTS", result);
        })
        .catch(() => {
          // eslint-disable-next-line no-console
          console.log("No se han cargado los comentarios");
        });
      // eslint-disable-next-line no-console
    },
    saveComment({ state, rootState, commit, dispatch }, comment, id = "") {
      const topicID = router.currentRoute.params.topic_id;
      const projectID = router.currentRoute.params.project_id;
      const user = auth().currentUser;
      const commentsRef = firestore()
        .collection("Project")
        .doc(projectID)
        .collection("Topic")
        .doc(topicID)
        .collection("Comment");
      if (rootState.user.currentUser) {
        var owner = {};
        state.comment = comment;
        state.comment.topic_id = topicID;
        owner.full_name = rootState.user.currentUser.displayName;
        owner.email = user.email;
        state.comment.owner = owner;
        state.comment.parent_id = id;
        state.comment.total_votes = 0;
        state.comment.positive_votes = 0;
        commentsRef
          .add(state.comment)
          .then(() => {
            const lastComment = {
              last_comment: {
                creation_dt: state.comment.creation_dt,
                full_name: rootState.user.currentUser.displayName
              },
              total_comments: firestore.FieldValue.increment(1)
            };
            if (state.comment.agreement == "acuerdo") {
              lastComment["agree_comments"] = firestore.FieldValue.increment(1);
            }
            commit("discussion/UPDATE_TOPIC", lastComment, {
              root: true
            });
            dispatch("discussion/updateTopic", lastComment, { root: true });
            // eslint-disable-next-line no-console
            console.log("Comentario guardado");
            return true;
          })
          // eslint-disable-next-line no-console
          .catch(() => console.log("El comentario no fue guardado"));
        return false;
      }
    },
    // eslint-disable-next-line no-unused-vars
    listChild({ state, commit }, id) {
      const topicID = router.currentRoute.params.topic_id;
      const projectID = router.currentRoute.params.project_id;

      // eslint-disable-next-line no-console
      console.log(id);
      const refComentary = firestore()
        .collection("Project")
        .doc(projectID)
        .collection("Topic")
        .doc(topicID)
        .collection(`Comment`)
        .where("parent_id", "==", id)
        .limit(4);
      refComentary
        .get()
        .then(querySnapshot => {
          querySnapshot.docs;
        })
        .catch(err => {
          // eslint-disable-next-line no-console
          console.error(err);
          // eslint-disable-next-line no-console
          console.log("No se han cargado las replicas");
        });
    },
    vote({ rootState }, { id, votes }) {
      const topicID = router.currentRoute.params.topic_id;
      const projectID = router.currentRoute.params.project_id;
      // eslint-disable-next-line no-console
      const commentsRef = firestore()
        .collection("Project")
        .doc(projectID)
        .collection("Topic")
        .doc(topicID)
        .collection("Comment")
        .doc(id);
      if (rootState.user.currentUser) {
        const content = {};
        content.total_votes = votes;
        commentsRef
          .set(content, { merge: true })
          .then(() => {
            // eslint-disable-next-line no-console
            console.log("Votacion exitosa");
          })
          // eslint-disable-next-line no-console
          .catch(() => console.log("No se logro contemplar el voto"));
      }
    }
  },
  mutations: {
    INSERT_COMMENT: (state, comment) => {
      state.comment = comment;
    },
    INSERT_LIST_COMMENTS: (state, comment) => {
      // eslint-disable-next-line no-console
      state.commentary = comment;
    },
    INSERT_LIST_CHILD: (state, child) => {
      state.child.push(child);
    }
  },
  getters: {
    getComments: state => {
      const result = getNestedChildren(state.commentary, "");
      // eslint-disable-next-line no-console
      console.log(result);
      return result;
    }
  }
};
